// Remove only expired booking entries. Other stale keys must not erase a freshly prepared prescription.
export default function cleanupExpiredBookingSession() {
    for (const key of Object.keys(sessionStorage)) {
        let entry;
        try { entry = JSON.parse(sessionStorage.getItem(key)); } catch { continue; }
        if (!entry || typeof entry !== 'object' || !Object.prototype.hasOwnProperty.call(entry, 'expiredAt')) continue;
        if (!Number.isNaN(Date.parse(entry.expiredAt)) && new Date(entry.expiredAt).getTime() <= Date.now()) {
            sessionStorage.removeItem(key);
        }
    }
    return Boolean(sessionStorage.getItem('userInformation'));
}
